<template>
	<div class="dashboard1">
		<el-card shadow="none" style="border: none">
			<div style="display: flex; justify-content: flex-end">
				<div>
					<input
						type="text"
						v-model="search"
						:placeholder="`Search ${
							viewBy == 'location' ? 'Location' : 'User'
						}`"
						class="searchicon"
						style="width: 300px"
					/>
				</div>
				<div>
					<el-button
						icon="el-icon-download"
						style="margin-top: 0px; margin-left: 20px"
						class="button-class-new"
						@click="exportToCSV"
					>
						Download Reports
					</el-button>
				</div>
			</div>
		</el-card>

		<el-table :data="filteredTableData" height="500" class="reports-table2">
			<el-table-column
				label="Location"
				width="160px"
				style="word-break: break-word; text-transform: capitalize"
				fixed="left"
			>
				<template slot="header" slot-scope="scope">
					Location
					<el-popover placement="right" trigger="click">
						<el-input
							v-model="searched_Location"
							size="mini"
							:placeholder="`Search ${
								viewBy == 'location' ? 'Location' : 'User'
							}`"
						></el-input>
						<div style="max-height: 200px; overflow: auto; margin-top: 10px">
							<el-checkbox-group v-model="selected_Location">
								<el-checkbox
									v-for="(formItem, index) in uniqueLocationNamesMoM.filter(
										(el) =>
											!searched_Location ||
											el.toLowerCase().includes(searched_Location.toLowerCase())
									)"
									:key="index"
									class="mb-2 checkbox-lable"
									:label="formItem"
									style="display: block"
								></el-checkbox>
							</el-checkbox-group>
						</div>
						<div class="flex justify-between mt-4">
							<span
								class="text-xs cursor-pointer primary-theme-color"
								@click="selected_Location = [...uniqueLocationNamesMoM]"
								>Select all</span
							>
							<span
								class="text-xs cursor-pointer"
								@click="selected_Location = []"
								>Reset</span
							>
						</div>
						<span slot="reference">
							<img
								v-if="selected_Location.length"
								src="../../../../assets/images/filter.png"
								width="9"
								class="cursor-pointer"
							/>
							<img
								v-else
								src="../../../../assets/images/filterBlack.png"
								width="9"
								class="cursor-pointer"
							/>
						</span>
					</el-popover>
				</template>
				<template slot-scope="scope">
					<div
						style="text-transform: capitalize; word-break: break-word"
						:style="scope.$index == 0 ? 'font-weight:bold' : ''"
					>
						{{ scope.row.location }}
					</div>
				</template>
			</el-table-column>
			<el-table-column
				v-for="(header, index) in dynamicHeaders"
				:key="index"
				:label="header.name"
				:width="getColumnWidth(index)"
			>
				<template v-slot="scope">
					<div v-if="scope.row[header.name.toLowerCase()]">
						{{ scope.row[header.name.toLowerCase()] }}
					</div>
					<div v-else>0%</div>
				</template>
			</el-table-column>
		</el-table>
		<el-row :gutter="10" class="mt-3">
			<el-col :span="8" class="text-left">
				<div>
					<b>Showing</b> {{ startNumberMOM }} to {{ endNumberMOM }} of
					{{ all_location_list.length }} results
				</div>
			</el-col>
			<el-col :span="8" class="text-center">
				<el-select
					v-model="perPage"
					name="per_page"
					placeholder="select per page"
					style="width: 90px !important"
					size="mini"
				>
					<el-option label="10" :value="10"></el-option>
					<el-option label="25" :value="25"></el-option>
					<el-option label="50" :value="50"></el-option>
					<el-option label="100" :value="100"></el-option>
				</el-select>
				&nbsp;<b>per page</b>
			</el-col>
			<el-col :span="8" class="text-right">
				<el-pagination
					background
					layout="prev, pager, next"
					:total="all_location_list.length"
					:page-size="perPage"
					:current-page.sync="currentPage"
				></el-pagination>
			</el-col>
		</el-row>
	</div>
</template>

<script>
export default {
	props: {
		tableData: Array,
		all_location_list: Array,
		viewBy: String,
		FormsSummary: Array,
	},
	data: () => ({
		dynamicHeaders: [],
		tableData1: [],
		searched_Location: "",
		selected_Location: [],
		currentPage: 1,
		perPage: 10,
		search: "",
	}),
	mounted() {
		this.initializeTableData();
	},
	computed: {
		filteredTableData() {
			let result = this.tableData1;
			if (this.selected_Location && this.selected_Location.length) {
				result = result.filter((el) =>
					this.selected_Location.includes(el.location)
				);
			}
			if (this.search && this.search.length) {
				result = result.filter((el) =>
					el.location.toLowerCase().includes(this.search.toLowerCase())
				);
			}
			const staticRow = {
				location: `India`,
				...this.dynamicHeaders.reduce((acc, header) => {
					let matchedForm = this.FormsSummary.find(
						(form) => form.name === header.name
					);
					acc[header.name.toLowerCase()] = matchedForm
						? `${matchedForm["completed_score_%"]}%`
						: "Static Value";
					return acc;
				}, {}),
			};
			const paginatedResult = result.filter(
				(el, index) =>
					index >= this.startNumberMOM - 1 && index < this.endNumberMOM
			);
			// return paginatedResult;
			return [staticRow, ...paginatedResult];
		},
		startNumberMOM() {
			let start = this.currentPage * this.perPage - (this.perPage - 1);
			return start;
		},
		endNumberMOM() {
			let end = Math.min(
				this.startNumberMOM + this.perPage - 1,
				this.all_location_list.length
			);
			return end;
		},
		uniqueLocationNamesMoM() {
			let arr = [...new Set(this.all_location_list.map((el) => el.location))];
			return arr;
		},
	},
	methods: {
		exportToCSV() {
			const rows = this.tableData1;
			const columns = [
				"Location",
				...this.dynamicHeaders.map((header) => header.name),
			];
			const csvContent = [
				columns.join(","),
				...rows.map((row) =>
					[
						row.location && typeof row.location === "string"
							? row.location.replaceAll(",", " ")
							: row.location,
						...this.dynamicHeaders.map((col) => {
							const value = row[col.name.toLowerCase()] || "0%";
							return typeof value === "string"
								? value.replaceAll(",", " ")
								: value;
						}),
					].join(",")
				),
			].join("\n");
			const blob = new Blob([csvContent], { type: "text/csv" });
			const url = window.URL.createObjectURL(blob);
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", "PerformanceByFormsReport.csv");
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			window.URL.revokeObjectURL(url);
			let tableData1 = this.tableData1;
			this.tableData1 = [];
			let dynamicHeaders = this.dynamicHeaders;
			this.dynamicHeaders = [];
			this.tableData1 = tableData1;
			this.dynamicHeaders = dynamicHeaders;
		},
		getColumnWidth(index) {
			// Define logic to return width based on index
			// For example, return different widths for different indices
			if (index === 0) {
				return "200px"; // Set width for first column
			} else {
				return "150px"; // Default width for other columns
			}
		},
		getTblData(item, dynamicKey) {
			return item[dynamicKey];
		},

		initializeTableData() {
			this.tableData1 = [];
			this.dynamicHeaders = [];
			let locations = new Set();
			this.tableData.forEach((category) => {
				category.arr.forEach((item) => {
					locations.add(item.location);
				});
			});
			this.dynamicHeaders = this.tableData.map((category) => {
				let name = category.name; // Get the name directly from the category
				// let score = category.arr.find((e) => e.name === name); // Find the score based on the name
				return {
					name: name,
					// score: score ? score['score_completion_%'] : null, // Include the score if found, otherwise null
				};
			});

			this.tableData1 = Array.from(locations).map((location) => {
				let rowData = { location: location };
				this.tableData.forEach((category) => {
					let data = category.arr.find((item) => item.location === location);
					if (data) {
						rowData[
							category.name.toLowerCase()
						] = `${data["completed_score_%"]}%`;
					} else {
						rowData[category.name.toLowerCase()] = "0%";
					}
				});
				return rowData;
			});
		},
	},
};
</script>
<style lang="scss">
.dashboard1 {
	.reports-table2 {
		background-color: #ffffff;
		color: #333333;
		font-family: inherit !important;
		text-transform: none !important;
		text-align: center !important;
		.el-table th.el-table__cell > .cell {
			text-align: center !important;
			color: #333333 !important;
			text-transform: none !important;
		}
		tbody tr td {
			text-align: center !important;
		}
		.el-table thead.is-group th.el-table__cell {
			background: white !important;
		}
		.el-table tr {
			background-color: #fff;
			border-bottom: 1px solid #ebeef5;
			font-size: 13px;
			text-align: center !important;
		}
		.el-table__body-wrapper {
			overflow-y: auto;
			overflow-x: auto;
			min-height: 62vh;
			max-height: 62vh;
		}
		.el-table__body-wrapper .el-table__row:first-child {
			font-weight: bold;
		}
	}
}
</style>
